/**
 * [SDKR-R2 · #369] ticket create replay contract (SDK-READINESS-CONTRACTS §5 — ค่าตายตัว)
 *
 * Dedupe namespace ของ POST /api/v1/service/tickets = (client_id, idempotency_key) หน้าต่าง 24 ชม.
 * นับจาก original created time (ไม่ต่ออายุ ไม่ rolling) — key rotation ของ client เดิม replay ได้
 * · แถวเก่า (`idempotency_keys` namespace ต่อ api key) ต้องถูก reconcile เสมอ
 *
 * request_hash เป็น **raw-v1**: sha256 ของ request bytes ดิบตามระบบเดิม (byte-identity contract) —
 * payload เท่ากันแต่ key order/whitespace ต่าง = 409 โดยเจตนา · การเปลี่ยนกติกา hashing
 * (เช่น canonical semantic hash) ต้องเป็น hash_version ใหม่เท่านั้น ห้ามแก้ raw-v1
 */
import { z } from "zod";

/** หน้าต่าง idempotency ของ ticket create (นับจาก original_created_at ของ receipt) */
export const TICKET_CREATE_IDEMPOTENCY_WINDOW_MS = 24 * 60 * 60 * 1000;

/** hash_version ที่ระบบรู้จัก — `raw-v1` = sha256 hex ของ request bytes ดิบ (ห้าม canonicalize) */
export const TICKET_CREATE_HASH_VERSIONS = ["raw-v1"] as const;
export const TicketCreateHashVersion = z.enum(TICKET_CREATE_HASH_VERSIONS);
export type TicketCreateHashVersion = z.infer<typeof TicketCreateHashVersion>;

/**
 * reason_code ที่ replay path ตอบใน `ErrorResponse.error.reason_code` (freeze §4) —
 * `idempotency_conflict`: key เดิมชน body ที่ bytes ต่างกัน (ledger ใหม่และ legacy path)
 * `idempotency_legacy_collision`: legacy receipt มี ticket/hash ต่างกัน >1 ชุดต่อ (client,key) — ห้ามเลือกผู้ชนะ
 */
export const TICKET_CREATE_REPLAY_REASON_CODES = ["idempotency_conflict", "idempotency_legacy_collision"] as const;
export const TicketCreateReplayReasonCode = z.enum(TICKET_CREATE_REPLAY_REASON_CODES);
export type TicketCreateReplayReasonCode = z.infer<typeof TicketCreateReplayReasonCode>;
